import(/* webpackMode: "eager" */ "/var/www/service-geek/apps/web/src/app/error.tsx");
